<template>
  <div id="app">
    <el-header class="header" v-if="!pathList.includes($route.path)">
      <index-header></index-header>
    </el-header>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import IndexHeader from './components/views/header'
export default {
  name: 'App',
  components: {
    IndexHeader
  },
  created () {
    console.log(this.$route.path)
  },
  data () {
    return {
      pathList: [
        '/userAgreement',
        '/shareRegister',
        '/H5inviter',
        '/privacy'
      ]
    }
  }
}
</script>

<style>
html,body{
  width:100%;
  height:100%;
  background: #fafafa;
}
#app {
  color: #353643;
  font-family: Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* padding-bottom: 60px; */
  background: #fafafa;
  overflow:auto;
  height: 100%;
}
*{
  margin:0;
  padding:0;
}
body{
  margin: 0 !important;
  font-family: Arial;
}
a{
  text-decoration: none;
}
ul,li{
  list-style:none;
}
.header{
  background: #FF904D;
}
</style>



// WEBPACK FOOTER //
// src/App.vue